import { Toasts } from '@fourthwall/components'
import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop'

import type { FormValues } from '../General.types'
import { useShopRendererDataQuery } from '../queries/useShopRendererDataQuery'
import { useUpdateShopMutation } from '../queries/useUpdateShopMutation'
import { useUpdateShopRendererMutation } from '../queries/useUpdateShopRendererMutation'

export const useGeneralShopSettings = () => {
  const { invalidateCurrentShopQuery, currentShop } = useCurrentShop()
  const { shopRendererDataQuery, invalidateShopRendererDataQuery } = useShopRendererDataQuery(
    [{ shop_id: currentShop?.id! }],
    {
      enabled: false,
    },
  )

  const { updateShopMutation } = useUpdateShopMutation()
  const { updateShopRendererMutation } = useUpdateShopRendererMutation()

  const handleUpdateShop = async (values: FormValues) => {
    if (currentShop?.id) {
      try {
        await Promise.all([
          await updateShopMutation.mutateAsync([
            currentShop.id,
            {
              name: values.name,
              customerSupportEmail: values.customerSupportEmail,
              creatorName: values.creatorName,
              description: values.description,
              timeZone: values.timezone,
            },
          ]),
          await updateShopRendererMutation.mutateAsync([
            { shop_id: currentShop.id },
            {
              shop: {
                ogImage: {
                  data: values.socialImageType === 'New' ? values.socialImage : '',
                  type: values.socialImageType,
                },
                cookiePolicy: values.cookiePolicy ? 'ShowInEu' : 'Hide',
              },
            },
          ]),
        ])

        invalidateCurrentShopQuery()
        invalidateShopRendererDataQuery()

        Toasts.notify('Settings saved', { type: 'info' })
      } catch (error) {
        Toasts.notify('Failed to update shop details. Please try again.')
      }
    }
  }

  return {
    currentShop,
    shopRendererDataQuery,
    handleUpdateShop,
    isSubmitting: updateShopMutation.isLoading || updateShopRendererMutation.isLoading,
  }
}
